import { Inject, Injectable } from "@angular/core";
import {
    IPublicClientApplication,
    AccountInfo,
    EndSessionRequest,
    AuthorizationUrlRequest,
    AuthenticationResult,
    PopupRequest,
    RedirectRequest,
    SilentRequest
} from "@azure/msal-browser";
import { MSAL_INSTANCE } from "./constants";
import { Observable, from } from 'rxjs';
import { Location } from '@angular/common';
import { IMsalService } from "./IMsalService";
@Injectable()
export class MsalService implements IMsalService {
    private redirectHash: any;
    constructor(
        @Inject(MSAL_INSTANCE) public instance: IPublicClientApplication,
        private location: Location
    ) {
        // Cache only actual auth response hashes before Angular router clears them.
        // Angular hash routes like "#/workflow" must not be forwarded to MSAL.
        const fullPathWithHash = this.location.path(true);
        const rawHash = fullPathWithHash.includes('#') ? fullPathWithHash.split('#').pop() || "" : "";
        const normalizedHash = rawHash.startsWith("/") ? rawHash.slice(1) : rawHash;
        const looksLikeAuthHash = /(code=|error=|state=|id_token=|access_token=)/.test(normalizedHash);

        if (looksLikeAuthHash) {
            this.redirectHash = `#${rawHash}`;
        }
    }
    acquireTokenPopup(request: PopupRequest): Observable<AuthenticationResult> {
        return from(this.instance.acquireTokenPopup(request));
    }
    acquireTokenRedirect(request: RedirectRequest): Observable<void> {
        return from(this.instance.acquireTokenRedirect(request));
    }
    acquireTokenSilent(silentRequest: SilentRequest): Observable<AuthenticationResult> {
        return from(this.instance.acquireTokenSilent(silentRequest));
    }
    handleRedirectObservable(): Observable<AuthenticationResult> {
        return (from(this.instance.handleRedirectPromise(this.redirectHash))) as any;
    }
    loginPopup(request?: PopupRequest): Observable<AuthenticationResult> {
        return from(this.instance.loginPopup(request));
    }
    loginRedirect(request?: RedirectRequest): Observable<void> {
        return from(this.instance.loginRedirect(request));
    }
    logout(logoutRequest?: EndSessionRequest): Observable<void> {
        return from(this.instance.logout(logoutRequest));
    }
    ssoSilent(request: SilentRequest): Observable<AuthenticationResult> {
        return from(this.instance.ssoSilent(request));
    }

}
